import { createUseStyles } from 'react-jss';
export const useStyles = createUseStyles({
  primaryFieldContainer: {
    position: 'absolute',
    top: ({
      theme
    }) => theme.scale * 60,
    maxWidth: ({
      theme
    }) => theme.scale * 320
  }
});
//# sourceMappingURL=styles.js.map